import { endpoints } from '../endpoints'
import { http } from '../http'
import { Reactable, Reaction, ReactionByID, ReactionParams } from '../../types'

export const reactions = {
  create: (params: ReactionParams): Promise<Reaction> =>
    http.post(endpoints.reactions, { reaction: params }),
  loadForCase: (caseID: number, email: string, reactable: Reactable): Promise<ReactionByID> =>
    http.get(`${endpoints.caseVisitorUserReactions(caseID)}?email=${email}&reactable=${reactable}`),
  destroy: (reactionID: number): Promise<void> =>
    http.destroy(`${endpoints.reactions}/${reactionID}`),
}
